import React from 'react'
import { ComponentTypes } from './types';
import Input from './shared/Input';
import Select from './shared/Select';
import Stat from './shared/Stat';
import Image from './shared/Image';
import Toggle from './shared/Toggle';
import Icon from './shared/Icon';



export const ComponentFactory = ({ component, allState, onChange, methods, componentState }: any) => {
    if(methods && methods(component.id)?.isVisible && !methods(component.id).isVisible(allState)) return <></>
    let preparedComponent = {...component, ...componentState};
    if(methods && methods(component.id)?.prepareData) {
        preparedComponent = methods(component.id).prepareData(preparedComponent, allState)
    }
    switch (preparedComponent.type) {
        case ComponentTypes.INPUT:
            return <Input onChange={onChange} component={preparedComponent}/>
        case ComponentTypes.TOGGLE:
            return <Toggle onChange={onChange} component={preparedComponent}/>
        case ComponentTypes.SELECT:
            return <Select onChange={onChange} component={preparedComponent}/>
        case ComponentTypes.STAT:
            return <Stat onChange={onChange} component={preparedComponent}/>
        case ComponentTypes.IMAGE:
            return <Image onChange={onChange} component={preparedComponent}/>
        case ComponentTypes.ICON:
            return <Icon onChange={onChange} component={preparedComponent}/>
        default:
            return <div>no-component</div>
    }
}
